import React, { useEffect } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from 'app/components/ui/alert-dialog';
import { toast } from 'sonner';
import { useProductsSlice } from 'app/pages/Product/slice';

interface Props {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  data: { id: string | number | null };
}

export function AlertProductAttributeValueDelete({
  isOpen,
  onOpenChange,
  data,
}: Props) {
  const { useDeleteProductsAttributeValueMutation } = useProductsSlice();
  const [
    deleteTags,
    { isLoading: isDeleting, error: deleteError, data: deletedData },
  ] = useDeleteProductsAttributeValueMutation();

  const handleDelete = () => {
    if (data?.id) {
      deleteTags(data.id);
    } else {
      toast.error('Invalid ID for deletion');
    }
  };

  useEffect(() => {
    if (deleteError) {
      console.error('Delete error:', deleteError);
      toast.error(deleteError?.message || 'An error occurred');
    }
  }, [deleteError]);

  useEffect(() => {
    if (deletedData) {
      toast.success(
        deletedData?.message || 'Attribute value deleted successfully',
      );
      onOpenChange(false);
    }
  }, [deletedData, onOpenChange]);

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleDelete} disabled={isDeleting}>
            {isDeleting ? 'Deleting...' : 'Continue'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
